export default class ItemOperario {
    IdUsuario: string;
    Nombre: string;

    constructor() {
        this.IdUsuario = "";
        this.Nombre = "";
    };
};
